export const PROFILE_CONTACTS_INITIATING = 'PROFILE_CONTACTS_INITIATING'
export const PROFILE_CONTACTS_INITIATED = 'PROFILE_CONTACTS_INITIATED'
export const PROFILE_CONTACTS_UPDATE = 'PROFILE_CONTACTS_UPDATE'
